import { render, staticRenderFns } from "./UserLimitConsumption.vue?vue&type=template&id=7809794a&scoped=true&"
import script from "./UserLimitConsumption.vue?vue&type=script&lang=js&"
export * from "./UserLimitConsumption.vue?vue&type=script&lang=js&"
import style0 from "./UserLimitConsumption.vue?vue&type=style&index=0&id=7809794a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7809794a",
  null
  
)

export default component.exports